const API_PREFIX = process.env.VUE_APP_ERUPT_API_PREFIX || '/erupt-api'
const IMAGE_PREFIX = process.env.VUE_APP_IMAGE_PREFIX || 'https://minio.dekalasers.net.cn:9000'

function requestJson(url, options = {}) {
  return fetch(url, options).then(async response => {
    const text = await response.text()
    let data = null

    try {
      data = text ? JSON.parse(text) : null
    } catch (error) {
      throw new Error('接口返回不是合法 JSON')
    }

    if (!response.ok) {
      throw new Error((data && (data.message || data.info)) || '接口请求失败')
    }

    return data
  })
}

export function listProvinces() {
  return requestJson(`${API_PREFIX}/org/province/list`)
}

export function listCities(provinceId) {
  return requestJson(`${API_PREFIX}/org/city/list?provinceId=${encodeURIComponent(provinceId)}`)
}

export function searchDealers(params) {
  return requestJson(`${API_PREFIX}/org/list`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      provinceId: params.provinceId,
      cityId: params.cityId,
      title: params.title
    })
  })
}

export function resolveImageUrl(imagePath) {
  if (!imagePath) return ''
  if (/^https?:\/\//i.test(imagePath)) return imagePath
  return `${IMAGE_PREFIX}${imagePath.startsWith('/') ? '' : '/'}${imagePath}`
}
